import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas } from "../../Utils/helpers";

const CustomStackedChart = ({ chartData }) => {
  const stackedChartConfig = useMemo(
    () => ({
      chart: {
        type: "column",
        // height: "400",
        // width: 500,
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 580,
            },
            chartOptions: {
              legend: {
                enabled: false,
              },
            },
          },
        ],
      },
      title: {
        text: chartData?.title ?? "",
        style: {
          fontWeight: "bold",
        },
      },

      xAxis: {
        categories: chartData?.labels,
      },
      yAxis: {
        reversedStacks: false,
        min: 0,
        max: chartData?.max ? 100 : undefined,
        title: {
          text: "",
        },
        labels: {
          formatter: function () {
            if (chartData?.format == "percentage") {
              return numberWithCommas(this.value) + "%";
            } else {
              return numberWithCommas(this.value);
            }
          },
        },
      },
      legend: {
        enabled: true,
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal",
        symbolRadius: "1",
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      tooltip: {
        headerFormat: "<b>{point.x}</b><br/>", // Custom header
        pointFormatter: function () {
          let value = this.y;
          let formattedValue = value;

          if (chartData?.format === "percentage") {
            formattedValue = numberWithCommas(value) + "%";
          } else {
            formattedValue = numberWithCommas(value);
          }

          return `<span style='color:${this.color}'>•</span> ${this.series.name}: <b>${formattedValue}</b>
            `;
        },
        style: {
          fontSize: "12px",
          padding: "10px",
          color: "#333",
        },
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: chartData?.datasets,
    }),
    [chartData]
  );

  return (
    <>
      <HighchartsReact highcharts={Highcharts} options={stackedChartConfig} />
    </>
  );
};

export default CustomStackedChart;
